import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  ITransferPricingDocumentationListParams,
  ITransferPricingDocumentationListResponse,
} from './types';

/** Pass null to disable the request entirely. */
export const useTransferPricingDocumentation = (
  params: ITransferPricingDocumentationListParams | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingDocumentationListResponse>(
      params
        ? TransferPricingDocumentationRequestHelper.listPath(params)
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    documentationRecords:
      data?.documentation ??
      TransferPricingDocumentationRequestHelper.NO_DOCUMENTATION,
    count: data?.count ?? 0,
    statusCounts:
      data?.statusCounts ??
      TransferPricingDocumentationRequestHelper.NO_STATUS_COUNTS,
    isLoading,
    error,
    mutate,
  };
};
